import React from "react";
import ReactDOM from "react-dom/client";
import 'react-quill/dist/quill.snow.css';
import "jsvectormap/dist/css/jsvectormap.css";
import 'react-toastify/dist/ReactToastify.css';
import 'react-modal-video/css/modal-video.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ConfigProvider } from "./context/GlobalContext";
import { initGlobalErrorHandler } from "./Utils/GlobalErrorHandler";
import ErrorBoundary from "./Utils/ErrorBoundary";
import * as Sentry from "@sentry/react";
import '@softnoesis/shakebug-js/dist/index.css';
import { Shakebug } from '@softnoesis/shakebug-js';
import ReactGA from "react-ga4";
import { initGA } from "./Utils/analytics";


Sentry.init({
  dsn: "https://6219a6f2b7c912ad5e6e4d295c8afe61@o1181255.ingest.us.sentry.io/4510680061706240",
  // Only capture errors in production — never during local development
  enabled: process.env.NODE_ENV === "production",
  environment: process.env.NODE_ENV, // tags events as "production" or "development"
  sendDefaultPii: true
});
const root = ReactDOM.createRoot(document.getElementById("root"));

initGlobalErrorHandler();
initGA();

root.render(
  <ConfigProvider>
    <ErrorBoundary>
      <Sentry.ErrorBoundary fallback={<p>App crashed</p>}>
        <App />

        <Shakebug
          appKey="bBAL7ZTDMatWFuFPbZyLLjXhE8XgzZ"
          bundleId="https://app.billnama.com"
          showFloatingButton={false}
          allowCrashReport={true}
          ShakebugThemeColor="#4759d6"
          makeLogEnabled={false}
        />

      </Sentry.ErrorBoundary>
    </ErrorBoundary>
  </ConfigProvider>
);

reportWebVitals();
